import { VerifyEmailPage } from '@/containers';

export const VerifyEmail = () => {
  return <VerifyEmailPage />;
};
